import includes from 'lodash/includes';
import {hasSelectedNotes} from 'api/reports/util/NotesUtils';

export const trackComparableSalesProperties = (payload, properties, comparableSales) => {
  if (payload.comparableSales) {
    const selectedComparables = comparableSales.selected.filter(id => !includes(comparableSales.featured, id));
    properties.push(
      {label: 'Number of Comparable Sales', value: selectedComparables.length},
      {label: 'Comparable Sales Chosen', value: selectedComparables},
      {
        label: 'Notes Added to Sales',
        value: comparableSales.selected.filter(id => hasSelectedNotes(id, 'selected.sales')).length
      }
    );
  }
};